import { useMutation, useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import {
  getFrontendTemplate,
  getFrontendTemplates,
  postSwitchFrontendTemplate,
  SwitchFrontendTemplatePayload,
} from "@api/challenges";

import Message from "@shared/services/message";

export const useFrontendTemplateList = () => {
  const query = useQuery({
    queryKey: ["challenge", "frontend-templates"],
    queryFn: async ({ signal }) => {
      const { result } = await getFrontendTemplates({
        signal,
      });

      return result;
    },
  });

  return query;
};

export const useFrontendTemplate = (templateId: string) => {
  const query = useQuery({
    queryKey: ["challenge", "frontend-templates", templateId],
    enabled: !!templateId,
    queryFn: async ({ signal }) => {
      const { result } = await getFrontendTemplate(templateId, {
        signal,
      });

      return result;
    },
  });

  return query;
};

export const useSwitchFrontendTemplate = ({
  applicantExamId,
  resultId,
  data,
}: {
  applicantExamId: number;
  resultId: string;
  data: SwitchFrontendTemplatePayload;
}) => {
  useForm({});
  const mutation = useMutation({
    mutationFn: async () => {
      await postSwitchFrontendTemplate({
        applicantExamId,
        resultId,
        options: {
          data,
        },
      });
    },
    onError: () => {
      toast.error(Message.getMessageByKey("switch-taken-by.template.failure"));
    },
  });

  return mutation;
};
